import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow-up\"><path d=\"m12 7.95 7.5 7.5-1.05 1.05L12 10.05 5.55 16.5 4.5 15.45l7.5-7.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol